import Icon from '@components/v2/ui/Icon/Icon';
import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import ListItemText from '@components/v2/ui/List/ListItemText';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { RefreshCw, Wifi } from 'lucide-react';
import { OfflineTestIds } from '../../../../../../utils/testIds/Offline.testIds';
import { UserMenuOfflineItemProps } from '../../userMenu.types';
import { useOfflineMenuItemStyles } from './offlineMenuItem.styles';

type OfflineMenuItemProps = Omit<UserMenuOfflineItemProps, 'show'>;

const OfflineMenuItem = ({
  isSyncing,
  isDisabled,
  label,
  tooltipContent,
  syncedPercentage,
  onClick,
}: OfflineMenuItemProps) => {
  const { classes } = useOfflineMenuItemStyles();

  return (
    <Tooltip TooltipContent={tooltipContent} placement="right" fullWidth>
      <MenuItem
        testId={OfflineTestIds.OPEN_OFFLINE_MODAL}
        disabled={isDisabled}
        className={classes.item}
        onClick={onClick}
      >
        <ListItemIcon>
          <Icon
            icon={isSyncing ? RefreshCw : Wifi}
            size="md"
            className={isSyncing ? classes.rotating : undefined}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography noWrap color="inherit" testId={OfflineTestIds.OPEN_OFFLINE_MODAL_LABEL}>
              {label}
              {syncedPercentage !== undefined && (
                <>
                  <span className={classes.separator}>·</span>
                  <span className={classes.percentage}>{syncedPercentage}%</span>
                </>
              )}
            </Typography>
          }
        />
      </MenuItem>
    </Tooltip>
  );
};

export default OfflineMenuItem;
